import constant from '@/constant'

export { momentLocales } from './momentLocales'

const enData = () => import('../../../public/languages/AhaSlides_English.json')
const viData = () => import('../../../public/languages/AhaSlides_Vietnamese.json')
const esData = () => import('../../../public/languages/AhaSlides_Spanish.json')
const seData = () => import('../../../public/languages/AhaSlides_Swedish.json')
const ptData = () => import('../../../public/languages/AhaSlides_Portuguese.json')
const frData = () => import('../../../public/languages/AhaSlides_French.json')
const deData = () => import('../../../public/languages/AhaSlides_German.json')
const idData = () => import('../../../public/languages/AhaSlides_id.json')
const itData = () => import('../../../public/languages/AhaSlides_Italian.json')
const trData = () => import('../../../public/languages/AhaSlides_Turkish.json')
const csData = () => import('../../../public/languages/AhaSlides_Czech.json')
const krData = () => import('../../../public/languages/AhaSlides_Korean.json')
const noData = () => import('../../../public/languages/AhaSlides_Norwegian.json')
const jaData = () => import('../../../public/languages/AhaSlides_Japanese.json')
const nlData = () => import('../../../public/languages/AhaSlides_Dutch.json')
const ruData = () => import('../../../public/languages/AhaSlides_Russian.json')
const plData = () => import('../../../public/languages/AhaSlides_Polish.json')
const daData = () => import('../../../public/languages/AhaSlides_Danish.json')
const zhData = () => import('../../../public/languages/AhaSlides_Simplified_Chinese.json')
const slData = () => import('../../../public/languages/AhaSlides_Slovenia.json')
const siData = () => import('../../../public/languages/AhaSlides_Slovenia.json')
const skData = () => import('../../../public/languages/AhaSlides_Slovakia.json')
const lvData = () => import('../../../public/languages/AhaSlides_lv.json')
const elData = () => import('../../../public/languages/AhaSlides_Greek.json')
const ltData = () => import('../../../public/languages/AhaSlides_Lithuanian.json')
const hrData = () => import('../../../public/languages/AhaSlides_Croatian.json')
const isData = () => import('../../../public/languages/AhaSlides_Icelandic.json')
const bgData = () => import('../../../public/languages/AhaSlides_Bulgarian.json')
const roData = () => import('../../../public/languages/AhaSlides_Romanian.json')
const huData = () => import('../../../public/languages/AhaSlides_Hungary.json')
const sqData = () => import('../../../public/languages/AhaSlides_Albanian.json')
const srLatData = () => import('../../../public/languages/AhaSlides_Serbian_Latin.json')
const srCyrData = () => import('../../../public/languages/AhaSlides_Serbian_Cyrillic.json')

const messages = {
  en: enData,
  vi: viData,
  es: esData,
  pt: ptData,
  fr: frData,
  de: deData,
  id: idData,
  it: itData,
  tr: trData,
  ja: jaData,
  nl: nlData,
  ru: ruData,
  pl: plData,
  da: daData,
  zh: zhData,
  sl: slData,
  si: siData,
  lv: lvData,
  cs: csData,
  kr: krData,
  no: noData,
  se: seData,
  el: elData,
  lt: ltData,
  hr: hrData,
  is: isData,
  bg: bgData,
  ro: roData,
  sk: skData,
  hu: huData,
  sq: sqData,
  'sr-latn': srLatData,
  'sr-cyrl': srCyrData,
}

const dataMessage = {}

export const getPresenterLanguageFromCdn = async (locale) => {
  if (dataMessage[locale]) {
    return dataMessage[locale]
  }
  let data = null
  try {
    if (locale === 'br') locale = 'pt'
    if (!messages[locale]) {
      locale = 'en'
    }
    const mod = await messages[locale]()
    data = mod.default
    window.localStorage.setItem('aha-default-language', JSON.stringify(data))
    dataMessage[locale] = data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    // do nothing
  }
  return data
}

export const getPresentingLanguageFromCdn = async (locale) => {
  if (dataMessage[locale]) {
    return dataMessage[locale]
  }
  let data = null
  try {
    if (locale === 'br') locale = 'pt'
    if (!messages[locale]) {
      locale = 'en'
    }
    const mod = await messages[locale]()
    data = mod.default
    dataMessage[locale] = data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    // do nothing
  }
  return data
}

export const getDefaultLanguageFallback = async () => {
  const defaultLanguageFallbackLocale = constant.defaultFallbackLocale
  if (dataMessage[defaultLanguageFallbackLocale]) {
    return dataMessage[defaultLanguageFallbackLocale]
  }
  let data = null
  try {
    const mod = await messages[defaultLanguageFallbackLocale]()
    data = mod.default
    dataMessage[defaultLanguageFallbackLocale] = data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    // do nothing
  }
  return data
}
